import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomElement } from '../../classes';
import { MultiTenantService } from '../../../../authentication/services/multi-tenant.service';
import { AuthenticationService } from '../../../../authentication/services/authentication.service';
import { BehaviorSubject, combineLatest, concat, Observable, of, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, debounceTime, map, switchMap, tap } from 'rxjs/operators';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Select2Component),
    multi: true
};

@Component({
    selector: 'chassis-select-2',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    providers: [
        CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR,
    ]
})
export class Select2Component extends CustomElement implements OnInit, OnDestroy {

    @Input() public data: any = {};

    @Input() public config: {
        url: string | (() => string);
        useScope: boolean,
    } = {
        url: null,
        useScope: false,
    };

    @Input() public attributes: any = {};

    @Input() public validation: any = {};

    protected subscription = new Subscription();

    protected headers$ = new BehaviorSubject({});

    public change$ = new BehaviorSubject<string>('');

    public options$: Observable<Array<any>>;

    public loading = false;

    constructor(
        protected authService: AuthenticationService,
        protected tenantService: MultiTenantService,
        protected http: HttpClient,
    ) {
        super();
    }

    public ngOnInit(): void {
        this.loadRemoteOptions();
    }

    private loadRemoteOptions(): void {
        this.options$ = concat(
            of([]),
            this.change$
                .pipe(
                    debounceTime(200),
                    tap(() => {
                        this.loading = true;
                    }),
                    switchMap(term => {
                        return combineLatest(
                            this.authService.tokenTrigger,
                            this.tenantService.onScopeChange()
                        )
                            .pipe(
                                switchMap(([token, scope]) => {
                                    const headers = {
                                        'Authorization': `Bearer ${token}`,
                                    };

                                    if (this.config.useScope) {
                                        headers['X-TenantScope'] = scope;
                                    }

                                    return this.http
                                        .get(this.url, {
                                            headers,
                                            params: {
                                                search: term || '',
                                            }
                                        })
                                        .pipe(
                                            catchError((error) => {
                                                return of([])
                                            }),
                                            tap((value) => {
                                                this.loading = false;
                                            }),
                                            map((result: { data: Array<any> }) => {
                                                return result.data;
                                            }),
                                        )
                                }),
                            );
                    }),
                ),
        );
    }

    public get url(): string {
        return this.config.url instanceof Function
            ? this.config.url()
            : this.config.url;
    }

    public get clearable(): boolean {
        return !this.validation.required;
    }

    public get value(): string {
        return this.innerValue || '';
    }

    public ngOnDestroy(): void {
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/select-2/select.component.ts